import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ConfirmationRequestPageBase } from '@bo-client/shared/base-components/confirmation-request-page.base';
import { RequestFormBase } from '@bo-client/shared/base-components/request-form.base';
import { uri } from '@bo-client/shared/constants/uri';
import { RequestApprovalDto } from '@bo-client/activation-management/grid-registration/model/RequestApprovalDto';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpHapService } from '@bo-client/core/http/http-hap.service';
import { ToastrService } from 'ngx-toastr';
import { GridRegistrationModel } from '@bo-client/activation-management/grid-registration/model/grid-registration.model';
import { GridRegistrationRequestService } from '@bo-client/activation-management/grid-registration/grid-registration-request.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-gr-assign-technician-confirmation',
  templateUrl: './gr-assign-technician-confirmation.component.html',
  styleUrls: ['./gr-assign-technician-confirmation.component.scss']
})
export class GrAssignTechnicianConfirmationComponent
  extends ConfirmationRequestPageBase<GridRegistrationModel>
  implements OnInit, OnDestroy
{
  @ViewChild('form')
  public form: RequestFormBase<GridRegistrationModel>;
  public uriGetData = uri.cmGrAssignToTechnician;
  public requestApprovalDto: RequestApprovalDto;
  public compUnsubs$ = new Subject<void>();
  public actions = this.gridRegistrationRequestService.actions;

  public gridRegistrationDto: GridRegistrationModel = null;

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected httpService: HttpHapService,
    protected toastService: ToastrService,
    protected matDialog: MatDialog,
    protected gridRegistrationRequestService: GridRegistrationRequestService
  ) {
    super(route, router, httpService, toastService, matDialog);
    this.title = 'Bestätigung von Installateur';
  }

  ngOnInit() {
    super.init();
  }

  hookDataLoaded() {
    // entry Point after standard loading data
    this.gridRegistrationDto = this.model;
  }

  hookGetDataFromForm() {
    // entry Point to modify additionalData to save
    // in base Component additionaldata is loaded with the form structure
    this.requestApprovalDto.additionalData = this.model;
  }

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
